import { useCallback } from 'react';

import { Translate } from '@spazious/dollhouse-i18n';
import { useStore } from '@spazious/dollhouse-store';
import { UnitType } from '@spazious/dollhouse-types';
import { ChoiceButton, Flex, Typography } from '@spazious/dollhouse-uikit';

export const UnitsSelector = () => {
  const { set, measurementsUnit } = useStore();

  const availableUnits = [
    { label: 'Meter', value: UnitType.Meter },
    { label: 'Feet', value: UnitType.Feet },
  ];

  const handleChange = useCallback(
    (unit: string) => {
      set({
        measurementsUnit: unit,
      });
    },
    [set]
  );

  return (
    <Flex alignItems="center" gap="var(--spacing-gap)" justifyContent="space-between">
      <Typography>
        <Translate>Measurement Units in?</Translate>
      </Typography>
      <Flex gap="var(--spacing-gap)">
        {availableUnits.map((unit) => (
          <ChoiceButton
            key={unit.value}
            checked={measurementsUnit === unit.value}
            name="measurements"
            option={unit}
            style={{ minWidth: '60px', padding: '4px' }}
            onChange={handleChange}
          />
        ))}
      </Flex>
    </Flex>
  );
};
